import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';

import { cn } from '@shared/lib/cn';

import {
  TAB_ACTIVE_CLASS,
  TAB_INACTIVE_CLASS,
  TAB_SIZE_CLASS,
  type TabSize,
} from './tabs.constant';

export interface TabProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Figma `size`(높이 md 40 · sm 28). 기본 md */
  size?: TabSize;
  /** Figma `active`. `aria-selected` 가 된다 */
  active?: boolean;
  /** Figma `Label` */
  children?: ReactNode;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}

/**
 * 탭 한 칸(`role="tab"`) — Figma `_Tabs/Tab`. `role="tablist"` 안에 둔다.
 * 보통은 `Tabs` 가 그리고, 탭 줄을 직접 짜야 하는 곳(Drawer · 그래프 카드의 기간 탭)에서 따로 쓴다.
 */
export function Tab({
  size = 'md',
  active = false,
  children,
  className,
  type = 'button',
  ref,
  ...rest
}: TabProps) {
  return (
    <button
      ref={ref}
      type={type}
      role="tab"
      aria-selected={active}
      data-size={size}
      data-active={active}
      {...rest}
      className={cn(
        'inline-flex shrink-0 cursor-pointer items-center whitespace-nowrap select-none disabled:cursor-not-allowed disabled:text-fg-disabled',
        TAB_SIZE_CLASS[size],
        active ? TAB_ACTIVE_CLASS[size] : TAB_INACTIVE_CLASS[size],
        className,
      )}
    >
      {children}
    </button>
  );
}
